<!-- =========================================================================================
    File Name: Error404.vue
    Description: 404 Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
	<div>
		<div v-for="(settingsModel, name) in settings" :key="name">
			<div class="vx-row">
				<div class="vx-col pt-2 pb-2 w-full">
					<div v-if="settingsModel.type === 'bool'">
						<vs-checkbox
							v-model="form[settingsModel.name]"
							class="w-full"
						>
							{{ $t(`systemSettings.${settingsModel.name}`) }}
						</vs-checkbox>
					</div>
					<div v-else>
						not bool //TODO add later
					</div>
				</div>
			</div>
		</div>
		<div class="d-flex justify-start mt-4">
			<vs-button color="primary" @click="updateData" class="">
				{{ $t("save") }}
			</vs-button>
		</div>
	</div>
</template>

<script>
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";
import Vue from "vue";

export default {
	name: "SettingsForm",
	props: {
		settings: {
			type: Object,
			required: true,
		},
		category: {
			type: String,
			required: true
		}
	},
	components: {},
	mixins: [databaseManager, notifier],
	data() {
		return {
			form: {},
		};
	},
	computed: {},
	async mounted() {
		console.log('update data')
		this.setForm();
	},
	methods: {
		setForm() {
			const vm = this;
			Object.values(this.settings).forEach((settingsModel) => {
				let value;
				if(settingsModel.type === 'bool') {
					value = settingsModel.value == 1 ? true : false;
				}
				else {
					value = settingsModel.value;
				}
				Vue.set(vm.form, settingsModel.name, value)
			});
		},
		async updateData() {
			try {
				await this.dbSetSystemSettings({
					type: this.category,
					settings: this.form,
				});

				this.$emit('update');
			} catch (e) {
				this.notifyError(e.message);
			}
		}
	}
};
</script>
